import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiantou-down-cu",
  "use": "icon-jiantou-down-cu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiantou-down-cu\"><path d=\"M449.706667 705.92c34.986667 32.981333 89.6 32.981333 124.586666 0l354.645334-335.018667a48 48 0 0 0-65.877334-69.76L512 632.661333l-351.061333-331.52a48 48 0 0 0-63.744-1.92l-4.096 3.84a48 48 0 0 0 1.962666 67.84l354.688 335.018667z\" p-id=\"3807\" fill=\"#0F0629\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol